<template>
  <div class="report-content">
    <table border="1" cellspacing="0" cellpadding="0">
      <tbody>
        <tr>
          <td><span>病历号</span>
            <p v-html="info.mediId"></p></td>
          <td><span>门诊号</span>
            <p v-html="info.admissionId"></p></td>
          <td><span>住院号</span>
            <p v-html="info.admissionId"></p></td>
          <td class="info3"><span>就诊医院</span>
            <p v-html="info.hosName"></p></td>
        </tr>
        <tr>
          <td><span>患者姓名</span>
            <p v-html="info.patientName"></p></td>
          <td><span>年龄</span>
            <p v-html="info.patientAge"></p></td>
          <td><span>性别</span>
            <p v-html="info.patientSex"></p></td>
          <td class="info7"><span>检查类型</span>
            <p v-html="info.examTypeName"></p></td>
        </tr>
        <tr>
          <td><span>患者编号</span>
            <p v-html="info.patientId"></p></td>
          <td><span>检查编号</span>
            <p v-html="info.accessionNumber"></p></td>
          <td><span>申请科室</span>
            <p v-html="info.requestDepartment"></p></td>
          <td class="info11"><span>申请医生</span>
            <p v-html="info.requestDoctor"></p></td>
        </tr>
        <tr>
          <td><span>检查时间</span>
            <p v-html="info.studiesDoneDt"></p></td>
          <td class="info13" colspan="2"><span>检查项目</span>
            <p v-html="info.examBodyName"></p></td>
          <td class="info14"><span>阴阳性</span>
            <p v-html="info.masculineFlag "></p></td>
        </tr>
        <tr>
          <td class="info15"  colspan="4"><span>临床诊断</span>
            <p v-html="info.cinicalDiagnosis"></p></td>
        </tr>
        <tr>
          <td class="info16"  colspan="4"><span>影像所见</span>
            <p v-html="info.reportEvidences"></p></td>
        </tr>
        <tr>
          <td class="info17"  colspan="4"><span>诊断结果</span>
            <p v-html="info.reportConclusion"></p></td>
        </tr>
        <tr>
          <td class="info18"><span>书写医生</span>
            <p v-html="info.reportDoctor"></p></td>
          <td class="info19"><span>审核医生</span>
            <p v-html="info.approveDoctor"></p></td>
          <td class="info20" colspan="2"><span>报告时间</span>
            <p v-html="info.approveDt"></p></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script type="text/ecmascript-6">

  const labels = ['病案号', '门诊号', '住院号', '就诊医院', '患者姓名', '年龄', '性别', '检查类型', '患者编号', '检查编号', '申请科室', '申请医生', '检查时间', '检查项目', '阴阳性', '临床争诊断', '影像所见', '诊断结果', '书写医生', '审核医生', '报告时间',]

  export default {
    props: {
      /*reportInfo: {
        type: Object,
        default: function () {
          return {}
        }
      },*/
      // info: {
      //   type: Object,
      //   default: function () {
      //     return {
      //       reportType: '',
      //       reportInfo: {},
      //     }
      //   }
      // }
        info: {
        type: Object,
        default: function () {
          return {
            reportType: '',
            reportInfo: {},
          }
        }
      }
    },
    data() {
      return {
        labels: labels,
      }
    },
    mounted() {
    },
    methods: {
    },
    updated() {
    },
    created() {

    }
  }
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
  @import '~@/common/css/variable'

  .report-content
    width: 100%
    table
      width 100%
      border-collapse:collapse;
      border-right:0
      border-bottom:1px solid $border-color

      tr
        td
          vertical-align: middle
          width: 25%
          min-height: 34px
          border 1px solid $border-color
          span
            display inline-block
            float left
            line-height 34px
            min-width: 80px
            height:100%
            text-align: center
          p
            display: flex;
            display: -ms-flexbox; /* TWEENER - IE 10 */
            color #000
            font-size:  13px;
            min-height 34px
            border-left 1px solid $border-color
            width: calc(100% - 104px);
            align-items: center;
            align-items:-ms-center;
            float: left;
            padding:2px 0 2px 6px;
            box-sizing: border-box
        .info3
        .info7
        .info11
          p
            border-right: none;
        .info14
        .info20
          p
            border-right: none;
        .info20
        .info13
          width: 50%
        .info15
        .info16
        .info17
          width: 100%
          p
            border-right: none;
        .info18
        .info19
        .info20
          border-bottom: none;

        .info16
        .info17
          p
            line-height: 25px;
</style>



// WEBPACK FOOTER //
// publicReport.vue?76798358